<template>
  <cms-deployed-content />
</template>

<script>
export default {
  components: {
    CmsDeployedContent: () => import('@/components/cms/deployed/CmsDeployedContent'),
  },
}
</script>